// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GcpGkeNetworkProviderType = {
  GkeNetworkProviderCalico: 'CALICO',
  GkeNetworkProviderNone: 'NONE',
} as const;
export type GcpGkeNetworkProviderType =
  (typeof GcpGkeNetworkProviderType)[keyof typeof GcpGkeNetworkProviderType];

export function instanceOfGcpGkeNetworkProviderType(value: any): boolean {
  for (const key in GcpGkeNetworkProviderType) {
    if (Object.prototype.hasOwnProperty.call(GcpGkeNetworkProviderType, key)) {
      if (
        GcpGkeNetworkProviderType[
          key as keyof typeof GcpGkeNetworkProviderType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GcpGkeNetworkProviderTypeFromJSON(
  json: any,
): GcpGkeNetworkProviderType {
  return GcpGkeNetworkProviderTypeFromJSONTyped(json, false);
}

export function GcpGkeNetworkProviderTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGkeNetworkProviderType {
  return json as GcpGkeNetworkProviderType;
}

export function GcpGkeNetworkProviderTypeToJSON(
  value?: GcpGkeNetworkProviderType | null,
): any {
  return value as any;
}

export function GcpGkeNetworkProviderTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GcpGkeNetworkProviderType {
  return value as GcpGkeNetworkProviderType;
}
